import React from 'react';
import AccountDetails from './AccountDetails';

// Public share view — same component, simpler chrome (no back button, shows public banner)
export default function PublicShare() {
  return <AccountDetails publicView />;
}
